module.exports = __webpack_public_path__ + "static/img/19.535a40e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka1/19.jpg
// module id = Zvj5
// module chunks = 16